// `stroke`/`fill` say which attribute the factory paints with `currentColor`.
// Stroke art uses Lucide's `strokeWidth` of 2 (viewBox units), which scales
// with the rendered box; filled art has none, so `size` maps only the box.
// `fixed` says neither: the colors are the art's own, baked into the SVG,
// so the factory paints nothing and `size` maps only the box.
export type IconPaintMode = "stroke" | "fill" | "fixed";

// Both default to Lucide's shape so the ~1,977 generated call sites, which
// pass no options, render byte-for-byte identically.
// Lucide's grid: the pixel value a token size resolves to in stroke mode.
export const STROKE_GRID_PIXELS = 24;

// What the root element fills with. `fixed` art carries its own color on
// every shape, so the root paints nothing there and leaves them alone.
export const ROOT_FILL_BY_PAINT: Record<IconPaintMode, string | undefined> = {
  fill: "currentColor",
  fixed: undefined,
  stroke: "none",
};

export type IconViewBox = `${number} ${number} ${number} ${number}`;

export type CreateIconOptions = {
  viewBox?: IconViewBox;
  paint?: IconPaintMode;
};
